/* eslint-disable */
/* tslint:disable */

import {
	AddUserParams,
	EmailParams,
	ProfileResponse,
	String,
	UpdateUserParams,
	UserResponse,
	UserRolesEditRequest,
	UserRolesList,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

class User<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
	/**
	 * @description указывать только один из параметров
	 *
	 * @tags Пользователи
	 * @summary Карточка пользователя/сотрудника
	 * @request GET:/user/profile
	 * @secure
	 */
	profileList = (
		query?: {
			/**
			 * User ID
			 * @format int32
			 */
			userid?: number;
			/**
			 * Employee ID
			 * @format int32
			 */
			employeeid?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ProfileResponse, void>({
			path: `/user/profile`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Карточка текущего пользователя
	 * @request GET:/user/profile/me
	 * @secure
	 */
	profileMeList = (params: RequestParams = {}) =>
		this.request<ProfileResponse, void>({
			path: `/user/profile/me`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Связать пользователя с сотрудником
	 * @request GET:/user/profile/bind
	 * @secure
	 */
	profileBindList = (
		query: {
			/**
			 * User ID
			 * @format int32
			 */
			userid: number;
			/**
			 * Employee ID
			 * @format int32
			 */
			employeeid: number;
		},
		params: RequestParams = {},
	) =>
		this.request<ProfileResponse, void>({
			path: `/user/profile/bind`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * @description только один из двух параметров
	 *
	 * @tags Пользователи
	 * @summary Отвязать пользователя от сотрудника
	 * @request DELETE:/user/profile/bind
	 * @secure
	 */
	profileBindDelete = (
		query?: {
			/**
			 * User ID
			 * @format int32
			 */
			userid?: number;
			/**
			 * Employee ID
			 * @format int32
			 */
			employeeid?: number;
		},
		params: RequestParams = {},
	) =>
		this.request<void, void>({
			path: `/user/profile/bind`,
			method: "DELETE",
			query: query,
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Добавление пользователя
	 * @request POST:/user
	 * @secure
	 */
	userCreate = (data: AddUserParams, params: RequestParams = {}) =>
		this.request<UserResponse, void>({
			path: `/user`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Изменить данные пользователя
	 * @request PUT:/user/{id}
	 * @secure
	 */
	userUpdate = (id: number, data: UpdateUserParams, params: RequestParams = {}) =>
		this.request<UserResponse, String | void>({
			path: `/user/${id}`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Переместить пользователя в архив
	 * @request POST:/user/archive/{id}
	 * @secure
	 */
	archiveCreate = (id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/archive/${id}`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Восстановить пользователя из архива
	 * @request POST:/user/un_archive/{id}
	 * @secure
	 */
	unArchiveCreate = (id?: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/un_archive/${id}`,
			method: "POST",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Сделать пользователя администратором
	 * @request GET:/user/{user}/role/admin
	 * @secure
	 */
	roleAdminDetail = (user: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/${user}/role/admin`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Отозвать права администратора у пользователя
	 * @request DELETE:/user/{user}/role/admin
	 * @secure
	 */
	roleAdminDelete = (user: number, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/${user}/role/admin`,
			method: "DELETE",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Получение списка ролей пользователя
	 * @request GET:/user/{user}/role/list
	 * @secure
	 */
	roleListDetail = (
		user: number,
		query: {
			/**
			 * номер страницы
			 * @format int32
			 */
			page: number;
			/**
			 * количество элементов (30)
			 * @format int32
			 */
			num?: number;
			/** строка поиска */
			query?: string;
		},
		params: RequestParams = {},
	) =>
		this.request<UserRolesList, void>({
			path: `/user/${user}/role/list`,
			method: "GET",
			query: query,
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Назначение ролей пользователя
	 * @request PUT:/user/{user}/role
	 * @secure
	 */
	roleUpdate = (user: number, data: UserRolesEditRequest, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/${user}/role`,
			method: "PUT",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Проверить наличие прав администратора
	 * @request GET:/user/permissions/admin
	 * @secure
	 */
	permissionsAdminList = (params: RequestParams = {}) =>
		this.request<boolean, void>({
			path: `/user/permissions/admin`,
			method: "GET",
			secure: true,
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Список прав пользователя в организации
	 * @request GET:/user/permissions/{organization}/list
	 * @secure
	 */
	permissionsListDetail = (organization: number, params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/user/permissions/${organization}/list`,
			method: "GET",
			secure: true,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи
	 * @summary Проверка прав пользователя в организации
	 * @request POST:/user/permissions/{organization}/check
	 * @secure
	 */
	permissionsCheckCreate = (organization: number, data: String[], params: RequestParams = {}) =>
		this.request<String[], void>({
			path: `/user/permissions/${organization}/check`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			format: "json",
			...params,
		});
	/**
	 * No description
	 *
	 * @tags Пользователи, Пользователи
	 * @summary Сброс пароля пользователя
	 * @request POST:/user/password/reset
	 * @secure
	 */
	passwordResetCreate = (data: EmailParams, params: RequestParams = {}) =>
		this.request<void, void>({
			path: `/user/password/reset`,
			method: "POST",
			body: data,
			secure: true,
			type: ContentType.Json,
			...params,
		});
}
export const userAPI = new User();
